import React, { Component } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import HR from '../Admin/Dashboard/HR/_HR';
import HRPayrollSidebar from './HRPayrollSidebar';


class HRDashboard extends Component {

  state = {}


  render() {

    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={t('HR Dashboard')} backBtn={true} />
            <div style={{ display: 'flex' }}>
              <HRPayrollSidebar />
              <div style={{ flex: 1, height: 'calc(100vh - 113px)', overflowY: 'auto', overflowX: 'hidden', paddingBottom: 10 }}>
                <div className='grey-section'>
                  <HR />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme
});

export default connect(mapStateToProps, null)(HRDashboard);
